"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PExtended = void 0;
var palias_1 = require("../../../PTypes/PAlias/palias.js");
var pstruct_1 = require("../../../PTypes/PStruct/pstruct.js");
var int_1 = require("../../../lib/std/int/index.js");
var type_system_1 = require("../../../type_system/index.js");
exports.PExtended = (0, pstruct_1.pstruct)({
    PNegInf: {},
    PFinite: { n: type_system_1.int },
    PPosInf: {}
});
var PPOSIXTime = (0, palias_1.palias)(type_system_1.int);
PPOSIXTime.from((0, int_1.pInt)(1));
